import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Box,
  Paper,
  TextField,
  Button,
  Typography,
	makeStyles,
} from "@material-ui/core";
import { Page } from "src/components";

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.default,
		minHeight: '100%',
		padding: theme.spacing(1)
	},
}));

interface AIMessage {
    sender: "user" | "ai" | string;
    text: string;
}

export default function AIAgentView() {
  const classes = useStyles();

  const [messages, setMessages] = useState<AIMessage[]>([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

	const handleSend = async () => {
  if (!input.trim()) return;

  // Add user message to chat
  const newMessages = [...messages, { sender: "user", text: input }];
  setMessages(newMessages);
  setInput("");
  setLoading(true);

  try {
    const res = await axios.post(
      "https://purix3ftd6tattb55263urghba0hjsxl.lambda-url.ap-northeast-1.on.aws/",
      { question: input }, // body payload
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const aiReply = res.data.geminiResponse
      ? JSON.stringify(res.data.geminiResponse, null, 2)
      : "No response";

    setMessages([...newMessages, { sender: "ai", text: aiReply }]);
  } catch (err) {
    setMessages([
      ...newMessages,
      { sender: "ai", text: "Error: " + JSON.stringify(err) },
    ]);
  } finally {
    setLoading(false);
  }
};

  return (
	<Page className={classes.root} title="AI Agent">
    <Container maxWidth="lg">
      {/* Chat window */}
      <Paper
        style={{
          height: "90vh",
          display: "flex",
          flexDirection: "column",
          padding: "16px",
        }}
      >
        {/* Messages */}
        <Box
          style={{
            flex: 1,
            overflowY: "auto",
            marginBottom: "16px",
          }}
        >
          {messages.map((msg, i) => (
            <Box
              key={i}
              display="flex"
              justifyContent={msg.sender === "user" ? "flex-end" : "flex-start"}
              mb={2}
            >
              <Paper
                style={{
                  padding: "8px 12px",
                  maxWidth: "70%",
                  backgroundColor:
                    msg.sender === "user" ? "#1976d2" : "#f5f5f5",
                  color: msg.sender === "user" ? "#fff" : "#000",
                }}
              >
                <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
                  {msg.text}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>

        {/* Input */}
        <Box display="flex">
          <TextField
            variant="outlined"
            placeholder="Ask a question..."
            fullWidth
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleSend()}
            disabled={loading}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSend}
            disabled={loading}
            style={{ marginLeft: "8px" }}
          >
            {loading ? "..." : "Send"}
          </Button>
        </Box>
      </Paper>
    </Container>
		</Page>
  );
}
